import React, { Component } from 'react';

import SizePosition from './SizePosition';
import SizeLength from './SizeLength';
import SizeArm from './SizeArm';
import SizeLeg from './SizeLeg';
import SizeRomp from './SizeRomp';
import Progress from "../../Progress";
import { withTranslation } from 'react-i18next';

class Sizes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			step: 1,
			position: props.position,
			length: props.length,
			weight: props.weight,
			sizes: props.sizes,
			romp: props.romp,
			arm: props.arm,
			leg: props.leg
		};

		this.handlePosition = this.handlePosition.bind(this);
		this.handleChangeLength = this.handleChangeLength.bind(this);
		this.handleChangeArm = this.handleChangeArm.bind(this);
		this.handleChangeRomp = this.handleChangeRomp.bind(this);
		this.handleChangeLeg = this.handleChangeLeg.bind(this);
		this.handleLengthWeight = this.handleLengthWeight.bind(this);
		this.handleArm = this.handleArm.bind(this);
		this.handleLeg = this.handleLeg.bind(this);
		this.handleRomp = this.handleRomp.bind(this);
		this.handleChangeWeight = this.handleChangeWeight.bind(this);
		this.goBack = this.goBack.bind(this);
		this.prevStep = this.prevStep.bind(this);
		this.nextAdviceStep = this.nextAdviceStep.bind(this);
		this.prevAdviceStep = this.prevAdviceStep.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			position: nextProps.position,
			length: nextProps.length,
			weight: nextProps.weight,
			sizes: nextProps.sizes,
			romp: nextProps.romp,
			arm: nextProps.arm,
			leg: nextProps.leg
		});
	}

	componentDidMount() {
	  window.scrollTo(0, 0);

	}

	render() {
		var formPart = '';
		switch(this.state.step) {
			case 2:
				formPart = <SizeLength
					traject={this.props.traject}
					handleSubmit={this.handleLengthWeight}
					length={this.state.length}
					weight={this.state.weight}
					history={this.props.history}
					noFit={this.props.noFit}
					t={this.props.t}
					nextAdviceStep={this.nextAdviceStep}
					back={this.prevStep}/>;
				break;
			case 3:
				formPart = <SizeArm
					traject={this.props.traject}
					handleSubmit={this.handleArm}
					arm={this.state.arm}
					length={this.state.length}
					noFit={this.props.noFit}
					history={this.props.history}
					t={this.props.t}
					nextAdviceStep={this.nextAdviceStep}
					back={this.prevStep}/>;
				break;
			case 4:
				formPart = <SizeLeg
					traject={this.props.traject}
					handleSubmit={this.handleLeg}
					leg={this.state.leg}
					noFit={this.props.noFit}
					length={this.state.length}
					history={this.props.history}
					t={this.props.t}
					nextAdviceStep={this.nextAdviceStep}
					back={this.prevStep}/>;
				break;
			case 5:
				formPart = <SizeRomp
					traject={this.props.traject}
					handleSubmit={this.handleRomp}
					romp={this.state.romp}
					noFit={this.props.noFit}
					length={this.state.length}
					history={this.props.history}
					t={this.props.t}
					finish={this.handleSubmit}
					nextAdviceStep={this.nextAdviceStep}
					back={this.prevStep}/>;
				break;
			case 1:
			default:
				formPart = <SizePosition
					traject={this.props.traject}
					handleSubmit={this.handlePosition}
					position={this.state.position}
					noFit={this.props.noFit}
					t={this.props.t}
					nextAdviceStep={this.nextAdviceStep}
					prevAdviceStep={this.prevAdviceStep}
					back={this.prevStep} />;
				break;
		}

		return(
			<div className="container main">

				<div className="info-overlay"></div>
				<div className="more-info">
					<i className="closeInfo fas fa-times"></i>
					<div className="more-info-container">
							{this.props.t('MEER INFO')}
					</div>
				</div>

				<Progress goTo={this.props.goTo} step={2} traject={this.props.traject} />


				{formPart}



			</div>
		);

	}


	handlePosition(value) {
		this.nextStep();
		this.setState({position: value});
	}
	handleChangeLength(event) {
		this.setState({length: event.target.value * 10});
	}
	handleChangeArm(event) {
		this.setState({arm: event.target.value * 10});
	}
	handleChangeRomp(event) {
		this.setState({romp: event.target.value * 10});
	}
	handleChangeLeg(event) {
		this.setState({leg: event.target.value * 10});
	}
	handleChangeWeight(event) {
		this.setState({weight: event.target.value});
	}
	handleLengthWeight(length, weight) {
		this.nextStep();
		this.setState({length: length}, () => {
			this.props.handler(this.state.position, this.state.length, this.state.arm, this.state.romp, this.state.leg, this.state.weight);
		});
		this.setState({weight: weight}, () => {
			this.props.handler(this.state.position, this.state.length, this.state.arm, this.state.romp, this.state.leg, this.state.weight);
		});
	}
	handleArm(value) {
		this.nextStep();
		this.setState({arm: value}, () => {
			this.props.handler(this.state.position, this.state.length, this.state.arm, this.state.romp, this.state.leg, this.state.weight);
		});
	}
	handleLeg(value) {
		this.nextStep();
		this.setState({leg: value}, () => {
			this.props.handler(this.state.position, this.state.length, this.state.arm, this.state.romp, this.state.leg, this.state.weight);
		});
	}
	handleRomp(value) {
		this.setState({romp: value}, () => {
			this.props.handler(this.state.position, this.state.length, this.state.arm, this.state.romp, this.state.leg, this.state.weight)
				.then(() => this.nextAdviceStep(this.props.traject));
		});

	}
	nextStep() {
		this.setState({step: this.state.step + 1});
	}
	prevStep() {
		this.setState({step: this.state.step - 1});
	}

	nextAdviceStep()
	{
		this.props.goTo('/advice/price', this.props.traject);
	}

	prevAdviceStep()
	{
		this.props.goTo('/advice/sizes', this.props.traject);
	}

	goBack(event) {
		event.preventDefault();
		this.prevAdviceStep(this.props.traject);
	}
}

export default withTranslation('sizesBody')(Sizes);
